import React, { useState } from 'react';
import { Download, Smartphone, Monitor, Check } from 'lucide-react';
import { usePWA } from '../hooks/usePWA';

const InstallButton = ({ variant = 'primary', className = '' }) => {
  const { isInstallable, isInstalled, installApp } = usePWA();
  const [deviceType, setDeviceType] = useState(() => {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    return isMobile ? 'mobile' : 'desktop';
  });

  const handleInstall = async () => {
    console.log('InstallButton: Install button clicked');
    const success = await installApp();
    if (!success) {
      console.error('InstallButton: Installation failed or was cancelled');
      showManualInstructions();
    }
  };

  const showManualInstructions = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    let instructions = '';

    if (userAgent.includes('safari') && deviceType === 'mobile') {
      instructions = 'Tap the Share button and select "Add to Home Screen"';
    } else if (userAgent.includes('chrome') && deviceType === 'mobile') {
      instructions = 'Tap the menu (⋮) and select "Add to Home screen"';
    } else if (userAgent.includes('edge')) {
      instructions = 'Click the menu (⋯) → Apps → "Install this site as an app"';
    } else if (userAgent.includes('chrome')) {
      instructions = 'Look for the install icon in the address bar or click menu → "Install Shot Clock Dating"';
    } else {
      instructions = 'Look for "Install" or "Add to Home Screen" in your browser menu';
    }

    window.alert(`Install Shot Clock Dating:\n\n${instructions}`);
  };

  // Don't show if already installed
  if (isInstalled) {
    return (
      <div className={`inline-flex items-center space-x-2 px-4 py-2 rounded-lg bg-green-100 text-green-800 ${className}`}>
        <Check className="w-4 h-4" />
        <span className="text-sm font-medium">App Installed</span>
      </div>
    );
  }

  // Don't show if not installable
  if (!isInstallable) {
    console.log('InstallButton: Not showing - app is not installable');
    return null;
  }

  // Render based on variant
  if (variant === 'minimal') {
    return (
      <button
        onClick={handleInstall}
        className={`inline-flex items-center space-x-2 text-pink-600 hover:text-pink-700 transition-colors ${className}`}
        title="Install Shot Clock Dating"
      >
        <Download className="w-4 h-4" />
        <span className="text-sm font-medium">Install App</span>
      </button>
    );
  }

  if (variant === 'secondary') {
    return (
      <button
        onClick={handleInstall}
        className={`inline-flex items-center space-x-2 px-4 py-2 border-2 border-pink-500 text-pink-600 hover:bg-pink-50 rounded-lg transition-all duration-200 ${className}`}
      >
        {deviceType === 'mobile' ? <Smartphone className="w-4 h-4" /> : <Monitor className="w-4 h-4" />}
        <span className="font-medium">Install App</span>
      </button>
    );
  }

  // Primary variant (default)
  return (
    <button
      onClick={handleInstall}
      className={`inline-flex items-center space-x-3 px-6 py-3 bg-gradient-to-r from-pink-500 to-rose-600 text-white font-semibold rounded-xl hover:from-pink-600 hover:to-rose-700 hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl ${className}`}
    >
      <div className="flex items-center space-x-2">
        {deviceType === 'mobile' ? <Smartphone className="w-5 h-5" /> : <Monitor className="w-5 h-5" />}
        <Download className="w-5 h-5" />
      </div>
      <div className="text-left">
        <div className="text-sm font-bold">Install App</div>
        <div className="text-xs opacity-90">No app store needed</div>
      </div>
    </button>
  );
};

export default InstallButton;